<template>
  <v-data-iterator
      :items="smp"
      :items-per-page.sync="itemsPerPage"
      :page.sync="page"
      :search="search"
      :sort-by="sortBy.toLowerCase()"
      :sort-desc="sortDesc"
      hide-default-footer
    >
      <template v-slot:header>
        <v-toolbar
          dark
          color="blue darken-3"
          class="mb-1"
        >
          <v-text-field
            v-model="search"
            clearable
            flat
            solo-inverted
            hide-details
            prepend-inner-icon="mdi-magnify"
            label="Search"
          ></v-text-field>
          <template v-if="$vuetify.breakpoint.mdAndUp">
            <v-spacer></v-spacer>
            <v-select
              v-model="sortBy"
              flat
              solo-inverted
              hide-details
              :items="keys"
              prepend-inner-icon="mdi-magnify"
              label="Sort by"
            ></v-select>
            <v-spacer></v-spacer>
            <v-btn-toggle
              v-model="sortDesc"
              mandatory
            >
              <v-btn
                large
                depressed
                color="blue"
                :value="false"
              >
                <v-icon>mdi-arrow-up</v-icon>
              </v-btn>
              <v-btn
                large
                depressed
                color="blue"
                :value="true"
              >
                <v-icon>mdi-arrow-down</v-icon>
              </v-btn>
            </v-btn-toggle>
          </template>
        </v-toolbar>
      </template>

      <template v-slot:default="props">
        <v-row>
          <v-col
            v-for="item in props.items"
            :key="item._id"
            cols="12"
            sm="6"
            md="4"
            lg="3"
          >
          <v-card elevation="5">
            <v-card @click="consoleRouter(item._id)">
               <v-card-title class="d-flex align-center justify-center" style="font-size: 12.0pt;">
                {{ item._id }} | {{ item.location }}
              </v-card-title>
              <v-card-subtitle class="d-flex align-center justify-center" style="font-size: 9.0pt;">[S/N: {{ item.sn }}]</v-card-subtitle>
              <v-divider></v-divider>

    <v-simple-table id="mytable" dense>
    <template v-slot:default>
      <tbody>
        <tr>
          <td style="background: rgba(138, 131, 131, 0.348);">Activity</td> 
          <td style="background: rgba(138, 131, 131, 0.348);">Status <v-icon v-if="lastOnline(item.timestamp) < 10" color="green">mdi-circle</v-icon>
          <v-icon v-else>mdi-circle</v-icon></td>
        </tr>
        <tr>
          <td>Seismic</td>
          <td v-if="item.seismic_event > 0" style="color: red;">Alert(s) {{item.seismic_event}}</td>
          <td v-else style="color: green;">OK</td>
        </tr>
        <tr>
          <td>Noise</td>
          <td v-if="item.sound_event > 0" style="color: red;">Alert(s) {{item.sound_event}}</td>
          <td v-else style="color: green;">OK</td>
        </tr>
        <tr>
          <td>Air Quality</td>
          <td v-if="item.air_quality_event > 0" style="color: red;">Alert(s) {{item.air_quality_event}}</td>
          <td v-else style="color: green;">OK</td>
        </tr>
        <tr>
          <td>Weather</td>
          <td v-if="item.weather_event > 0" style="color: red;">Alert(s) {{item.weather_event}}</td>
          <td v-else style="color: green;">OK</td>
        </tr>
        <tr>
          <td>Last Updated</td>
          <td v-if="lastUpdate(item.timestamp).includes('ago') == true">{{lastUpdate(item.timestamp)}}</td>
          <td v-else>{{lastUpdate(item.timestamp).substring(2)}} ago</td>
        </tr>
        <tr>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
      </v-card>
      <br>
      <v-card>
  <HereMap :center="map(item.latitude,item.longitude)" v-if="renderComponent"/>
  </v-card>
          </v-card>
      </v-col>
      </v-row>
      </template>

      <template v-slot:footer>
        <v-container>
        <v-row
          class="mt-2"
          align="center"
          justify="center"
        >
          <span class="grey--text">Items per page</span>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                dark
                text
                color="primary"
                class="ml-2"
                v-bind="attrs"
                v-on="on"
              >
                {{ itemsPerPage }}
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(number, index) in itemsPerPageArray"
                :key="index"
                @click="updateItemsPerPage(number)"
              >
                <v-list-item-title>{{ number }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-spacer></v-spacer>

          <span
            class="mr-4
            grey--text"
          >
            Page {{ page }} of {{ numberOfPages }}
          </span>
          <v-btn
            fab
            dark
            color="blue darken-3"
            class="mr-1"
            @click="formerPage"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn
            fab
            dark
            color="blue darken-3"
            class="ml-1"
            @click="nextPage"
          >
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-row>
        </v-container>
      </template>
    </v-data-iterator>
</template>

<script>
import router from "../router";
import moment from 'moment';
import HereMap from '../components/HereMapOverview.vue';

export default {
props: {
    smp: Array,
    renderComponent: Boolean
  },
    components: {
    HereMap
  },
   data () {
      return {
        itemsPerPageArray: [4, 8, 12],
        search: '',
        filter: {},
        sortDesc: false,
        page: 1,
        itemsPerPage: 4,
        sortBy: '_id',
        keys: [
          'Location',
        ],
      }
    },
    computed: {
      numberOfPages () {
        return Math.ceil(this.smp.length / this.itemsPerPage)
      },
      filteredKeys () {
        return this.keys.filter(key => key !== 'Name')
      },
    },
    methods: {
      darkMode() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      },
      lastUpdate(value) {
      return moment().from(moment(value))
      },
      lastOnline(value) {
      return moment().diff(moment(value), 'minutes')
      },
      map(lat,lon) {
      return this.center = {
          lat : lat,
          lng : lon
        }
      },
      consoleRouter(value) {
      router.push("/details/" + value);
      },
      nextPage () {
        if (this.page + 1 <= this.numberOfPages) this.page += 1
      },
      formerPage () {
        if (this.page - 1 >= 1) this.page -= 1
      },
      updateItemsPerPage (number) {
        this.itemsPerPage = number
      },
      },
}
</script>